export default __webpack_public_path__ + "static/PBJCAT-62777c224139b7ab92e376eb2c3896d1.gif";